import io from 'socket.io-client';

const socket = io(process.env.REACT_APP_API_URL, {
  path: '/bridge',
  transports: ['websocket'], // use WebSocket transport only
});
export default socket;
